export class ChatThreadDTO {
    id: string;
	username: string;
	threadId: string;
  }
